export default function Ethanol101() {
  return (
    <div>
      <h1>ETHANOL 101</h1>
      <h2>What you need to know about E10/ethanol fuel</h2>

      <h3>Problem #1</h3>
      <p>
        Ethanol is a powerful solvent and when first introduced it strips away
        any gums, varnish and other build up found in fuel tanks and fuel
        delivery systems. This debris drops into the fuel and leads to clogged
        filters, injectors and carburetors.
      </p>

      <h3>Problem #2</h3>
      <p>
        Ethanol attracts moisture from the atmosphere; chemically it forms an
        ethanol/water molecule. Water in the fuel causes engines to run rough,
        stall and can lead to internal damage to engine components. Fuel will
        naturally hold 0.5% water in suspension, but if water levels exceed this
        threshold, the water drops out of suspension. The water/ethanol
        molecules are heavier than the fuel and drop to the bottom of the tank.
        This is phase separation. Ethanol provides a significant amount of the
        fuel’s octane, so when the ethanol separates and drops to the bottom of
        the tank, the remaining fuel is left without enough octane to properly
        operate the engine. Plus, the ethanol/water mixture is only partially
        combustible which can lead to severe engine problems.
      </p>

      <h3>Problem #3</h3>
      <p>
        Ethanol and gasoline do not chemically bond, instead they are held
        together in a weak suspension. Over a short period of time the E10 fuel
        begins to break down. The fuel begins forming solids which can clog the
        fuel delivery system and reduce octane ratings.
      </p>

      <h3>Problem #4</h3>
      <p>
        Ethanol does not produce as much energy as gasoline, losing up to 20+%
        of its power. E10 Fuels result in decreased performance, reduced
        throttle response and greatly reduced fuel economy. Un-burnt fuel leads
        to carbon deposits.
      </p>

      <h3>How to Combat These Problems</h3>
      <p>
        To combat these problems we recommend the use of a fuel
        stabilizer/conditioner. Be careful of what additive you use, many are
        alcohol-based and adding alcohol to E10 can lead to additional engine
        problems. The additive we sell is designed to prevent the fuel’s
        breakdown for up to 1 year, prevent the formation of fuel related gums
        and varnishes, counter ethanol-induced octane problems, ensure easy
        starting after storage, absorb moisture to fight corrosion and contain
        oil to provide extra lubricity and protection. You get all this
        protection at just 1 ounce per 5 gallons. Be sure to use fuel
        stabilizer/conditioner with every fill up.
      </p>

      <p>
        For more about Ethanol, please consult your owner's manual or contact your local Harley-Davidson dealer.
      </p>

    </div>
  );
}
